import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const LinkedinIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        d="M2.68268 1C1.7528 1 1.00015 1.75531 1 2.68467C1 3.61494 1.75265 4.3701 2.68283 4.3701C3.61044 4.3701 4.36415 3.61494 4.36415 2.68467C4.36415 1.75516 3.61029 1 2.68268 1Z"
        fill="currentColor"
      />
      <path
        d="M4.13293 5.6485H1.23138V15H4.13293V5.6485Z"
        fill="currentColor"
      />
      <path
        d="M11.5196 5.41595C10.1081 5.41595 9.1617 6.19115 8.77431 6.92627H8.7355V5.64848H5.95265H5.9525V14.9998H8.85149V10.3737C8.85149 9.15406 9.08332 7.97272 10.5928 7.97272C12.0807 7.97272 12.1006 9.3676 12.1006 10.4519V14.9997H15V9.87048C15 7.35275 14.4577 5.41595 11.5196 5.41595Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default LinkedinIcon;
